module.exports = __webpack_public_path__ + "img/how_it_work.d998010f.png";